import React, { ReactNode } from 'react';

interface ScrollableCellProps {
  children: ReactNode;
}

export const ScrollableCell: React.FC<ScrollableCellProps> = ({ children }) => {
  // max-w-0 + min-w-full forces the wrapper to clamp to the parent td's
  // explicit column width even when speculo-ui's auto-width inner divs
  // don't propagate a constraint. With overflow-x-auto, content scrolls
  // horizontally within the td instead of bleeding into adjacent columns.
  return (
    <div className="max-w-0 min-w-full overflow-x-auto overflow-y-hidden scrollbar-gutter-stable [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-gray-300 [&::-webkit-scrollbar-track]:rounded-full [&::-webkit-scrollbar-track]:bg-gray-100 [&::-webkit-scrollbar]:h-1.5 [&::-webkit-scrollbar]:w-1.5">
      <div className="flex gap-1 whitespace-nowrap py-2">{children}</div>
    </div>
  );
};

export default ScrollableCell;
